<template>
  <gmap />
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
import gmap from "./components/Map.vue";

export default {
  name: "App",
  components: {
    gmap,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* color: #2c3e50;*/
  /* margin-top: 60px;*/
}
</style>

